import { Component } from "@angular/core";
import { ProdutoService } from "src/app/core/services/http/produto.service";
import { map } from "rxjs";
import { ProdutoFamiliaRequest } from "../../models/produto-familia.model";

@Component({
    selector: 'grupo',
    templateUrl: './grupo.component.html',
    styleUrls: ['./grupo.component.scss'],
})
export class GrupoComponent {
    public grupo: string = '';

    public grupos$ = this._produtoService
        .getProdutosFamilia()
        .pipe(map((l) => (l.success ? l.data : [])));

    constructor(
        private _produtoService: ProdutoService
    ) { }

    public adicionarGrupo() {
        const grupoRequest = new ProdutoFamiliaRequest();
        grupoRequest.nome = this.grupo;

        this._produtoService.adicionarProdutoFamilia(grupoRequest).subscribe((res) => {
            if (!res.success) return;

            this.atualizerGrupos();
            this.limparForm();
        });
    }

    public deletarGrupo(codigo: number) {
        this._produtoService.deletarProdutoFamilia(codigo).subscribe((res) => {
            if (!res.success) return;
            this.atualizerGrupos();
        });
    }

    public atualizerGrupos() {
        this.grupos$ = this._produtoService.getProdutosFamilia().pipe(map((l) => (l.success ? l.data : [])));
        this.limparForm();
    }

    public limparForm() {
        this.grupo = '';
    }
}